import { useEffect, useState } from 'react';
import { Api } from '../../componentes/Api';
import { Card, CardBody, CardTitle, Row, FormText, Col, CardHeader, Button, Modal, ModalHeader, ModalBody, Label, Input, FormGroup, ModalFooter } from "reactstrap"
import DataTable from 'react-data-table-component';
import Swal from 'sweetalert2';
import CagarImagenesArticulos from './CagarImagenesArticulos'
import Form from 'react-bootstrap/Form';
import { ToastContainer, toast } from 'react-toastify';


const modeloDatos = {
    articuloID: 0,
    empresaID: 0,
    descripcion: "",
    grupoArticulo: 0,
    tipoArticulo: 0,
    almacenPorDefecto: 1,
    codigoAuxiliar: "",
    costoPromedio: 1.00,
    precioPromedio: 1.00,
    precioPormayor: 1.00,
    marca: "",
    esOferta: false,
    paraBot: false,
    unidadMedida:"",
    creadoPor: "",
    modificadoPor: "",
    fechaCreado: new Date,
    fechaModificado: new Date,
    cantidadMinima: 1,
    cantidadMaxima: 1,
    tiempoExpiracionMeses: 1,
    tamano: "1",
    activoFijo: "1",
    ubicacionAlmacen: "1",
    imagen: "",
    activo: true,
    cambiarDescripcion: false,
    cambiarPrecio: false,
    itbisIncluido: false,
    margen: 1.00

}

const Articulos = () => {
    const [user, setUser] = useState(window.localStorage.getItem("sesion_usuario"))

    const [tabla, setTabla] = useState(modeloDatos);
    const [Listado, SetListado] = useState([]);
    const [ListadoDisponible, SetListadoDisponible] = useState([]);
    const [ListadoGrupoArt, SetListadoGrupoArt] = useState([]);
    const [ListadoUnidaMedida, SetListadoUnidaMedida] = useState([]);
    const [ListadoAlmacen, SetListadoAlmacen] = useState([]);
    const [pendiente, setPendiente] = useState(true);
    const [verModal, setVerModal] = useState(false);
    const [Listado1, SetListado1] = useState([]);
    const [busqueda, setbusqueda] = useState("");
    const [interativo, Setinterativo] = useState(false);
    const [imageSrc, setImageSrc] = useState("");
    const [file, setFile] = useState(null);
    const [verModalFoto, setverModalFoto] = useState(false);


    const toMoney = (value) => {
        const money = Number(value);

        if (isNaN(money)) {
            return value;
        }

        return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(money)
    }

    const onChange = async (e) => {
        var l = Listado1;
        setbusqueda(e.target.value);
     
        var searchData = l.filter((item) => {
            if (
                (item.codigoAuxiliar + item.descripcion + item.articuloID)
                    .toString()
                    .toLowerCase()
                    .includes(e.target.value.toLowerCase())
            ) {
                return item;
            }
        });
        SetListado(searchData);
    };
    let correo = JSON.parse(user).correo;


    const handleChange = (e) => {
        
        
        if (e.target.name == 'cambiarDescripcion') {
            e.target.value = !tabla.cambiarDescripcion;
        }
        if (e.target.name == 'cambiarPrecio') {
            e.target.value = !tabla.cambiarPrecio;
        }
        if (e.target.name == 'itbisIncluido') {
            e.target.value = !tabla.itbisIncluido;
        }
        if (e.target.name == 'esOferta') {
            e.target.value = !tabla.esOferta;
        } if (e.target.name == 'paraBot') {
            e.target.value = !tabla.paraBot;
        }
        let value = e.target.name === 'cambiarDescripcion'
            || e.target.name === 'cambiarPrecio' || e.target.name === 'itbisIncluido' || e.target.name === 'esOferta' || e.target.name === 'paraBot' ? (e.target.value == "true" ? true : false) : e.target.value;
      
        if (e.target.name == 'costoPromedio') {
            var precio = (value * ( tabla.margen / 100)) 
            precio = precio + parseFloat(value)
            setTabla({
                ...tabla,
                [e.target.name]: value, ["precioPromedio"]: precio
            })
        } else {
            setTabla({
                ...tabla,
                [e.target.name]: value
            })
        }

       
    }


    const handleFileChange = (e) => {
        setFile(e.target.files[0]);
    };

    const handleUpload = async () => {
        if (!file) return;

        const formData = new FormData();
        formData.append("image", file);

        const response = await fetch(Api + "VentasMantenimiento/UploadImage/" + tabla.articuloID, {
            method: "POST",
            body: formData,
        });

        const data = await response.json();
        fetchImage1();

        setFile(null)
        console.log("Respuesta:", data);
    };
    const fetchImage1 = async () => {
        const response = await fetch(Api + "VentasMantenimiento/MostraFoto/" + tabla.articuloID);
        const blob = await response.blob();
        setImageSrc(URL.createObjectURL(blob));
    };

   

    const obtenerDatos = async () => {
        let response = await fetch(Api + "VentasMantenimiento/listaArticulos/" + JSON.parse(user).correo);

        if (response.ok) {
            let data = await response.json()
            SetListado1(data)
            if (pendiente) {
                SetListado(data)
                setPendiente(false)
            }
       
           
        }
    }

    const obtenerDatosGrupoArt = async () => {
        let response = await fetch(Api + "categoria/Lista/" + correo);


        if (response.ok) {
            let data = await response.json()
            SetListadoGrupoArt(data)
            setPendiente(false)
        }
    }
    //const obtenerDatosUnidadMedida = async () => {
    //    let response = await fetch(Api + "VentasMantenimiento/ListaUnidadMedida");
    //    if (response.ok) {
    //        let data = await response.json()
    //        SetListadoUnidaMedida(data)
    //    }
    //}

    const obtenerDatosAlmacen = async () => {
        let response = await fetch(Api + "VentasMantenimiento/listaAlmacen");

        if (response.ok) {
            let data = await response.json()
            SetListadoAlmacen(data)
 
        }
    }

    const obtenerDisponible = async () => {
        let response = await fetch(Api + "VentasMantenimiento/ListaDisponible");

        if (response.ok) {
            let data = await response.json()
            SetListadoDisponible(data)

        }
    }
    const obtenerDatosSN = async () => {
        let response = await fetch(Api + "Administracion/SecuenciaNumerica");
        if (response.ok) {
            let data = await response.json();
            var a = data.filter(x => x.esncf == 0 && x.cod_Secuencia == "Articulo").map(z => (z.plantilla + z.siguiente))
            if (a.length == 0) {
                tabla.codigoAuxiliar = '';
            } else {
                tabla.codigoAuxiliar = a[0]
            }
        
        }
    }

    useEffect(() => {
        obtenerDatos();
   
    })
    useEffect(() => {
        obtenerDatosSN()
           obtenerDatosAlmacen();
        obtenerDatosGrupoArt();
        obtenerDisponible();
           //obtenerDatosUnidadMedida();

      
    },[])


    const guardarCambios = async () => {
        //tabla.empresaId = "PR";
        tabla.precioPromedio = parseFloat(tabla.precioPromedio)
        let response;
        if (tabla.articuloID == 0) {
            tabla.empresaID = ""+ JSON.parse(user).empresaID
            response = await fetch(Api + "VentasMantenimiento/GuardarArticulos", {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(tabla)
            })

        } else {
            response = await fetch(Api + "VentasMantenimiento/EditarArticulos", {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(tabla)
            })
        }

        if (response.ok) {
         setPendiente(true)
            obtenerDatos();
            setTabla(modeloDatos)
            setVerModal(!verModal);
       
            Swal.fire(
                'Guardado!',
                '',
                'success'
            )
            obtenerDatos()
          
        } else {
            alert("error al guardar")
        }
        obtenerDatosSN()

    }

    const InactivarDatos = async (id) => {
        let response = await fetch(Api + "VentasMantenimiento/InactivarArticulos/" + id, { method: "DELETE" })
        if(response.ok) {
            toast.success("Proceso realizado")
            setPendiente(true)
                            obtenerDatos();
                        }
    }

    const abrirEditarModal = (data) => {
        setTabla(data);
        setVerModal(!verModal);
        tabla.articuloID = data.articuloID
        fetchImage1()
    }
    const cerrarModal = () => {
        setTabla(modeloDatos)
        setVerModal(false)
        setverModalFoto(false)

    }

    const columns = [
        {
            name: 'Edit',
            cell: row => (
                <>
                    <Button color="primary" size="sm" className="mr-2"
                        onClick={() => abrirEditarModal(row)}
                    >
                        <i className="fas fa-pen-alt"></i>
                    </Button>
                    <Button color="primary" size="sm" className="mr-2"
                        onClick={() => (setverModalFoto(true), tabla.articuloID = row.articuloID, fetchImage1())} title="Cambiar Foto"
                    >
                        <i className="fas fa-images"></i>
                    </Button>
                </>
            ),
            width:"10%"
        },
       {
            name: 'Cod. auxil',
            selector: row => row.codigoAuxiliar,
           sortable: true,
           width: "15%"
        },  
        {
            name: 'Nombre de Articulo',
            selector: row => row.descripcion,
            sortable: true,
            width: "25%"
        },  {
            name: 'Precio',
            selector: row => (toMoney( row.precioPromedio) ),
            sortable: true,
        },

        //{
        //    name: 'Grupo Articulo',
        //    selector: row => (ListadoGrupoArt.filter(x => x.grupoArticuloID == row.grupoArticulo).map(x =>x.descripcion)),
        //    sortable: true,
        //}, 
        {
            name: 'Disponible',
            cell: row => (
                <>
                    {ListadoDisponible.filter(x => x.articuloID == row.articuloID && x.almacenID == row.almacenPorDefecto).map(x => x.cantidad)}
                </>
            )
        },

        {
            name: 'Estado',
      
            cell: row => (<><div>
                <Form>  <Form.Check 
                    type="switch"
                    id="activo"
                    checked={row.activo}
                    onChange={() => InactivarDatos(row.articuloID)}
                /></Form></div></>
            )
        }
        , 
        {
            name: 'Id',
            selector: row => row.articuloID,
            sortable: true,
        }, 
      
    ];

    const customStyles = {
        headCells: {
            style: {
                fontSize: '13px',
                fontWeight: 800,
            },
        },
        headRow: {
            style: {
                backgroundColor: "#eee",
            }
        }
    };

    const paginationComponentOptions = {
        rowsPerPageText: 'Filas por página',
        rangeSeparatorText: 'de',
        selectAllRowsItem: true,
        selectAllRowsItemText: 'Todos',
    };

    return (
        <>
    

            <Card>
                <CardHeader style={{ backgroundColor: '#4e73df', color: "white", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    Lista de Articulos
                    <a className="btn" color="primary"
                        onClick={() => Setinterativo(true)} >
                        <i >Guia</i>
                    </a>
                </CardHeader>
                <CardBody>
                    <Row><Col md={2}>     <Button color="success" size="sm"
                        onClick={() => setVerModal(!verModal)}
                    >Nuevo Articulo</Button>
                </Col>
                <Col md={4}>    <Input type="search" name="busqueda" onChange={(e) => onChange(e)} placeholder="Buscar  " ></Input> </Col>
            </Row>  
                    <hr></hr>
                    <DataTable
                        columns={columns}
                        data={Listado}
                        progressPending={pendiente}
                        pagination
                        paginationComponentOptions={paginationComponentOptions}
                        customStyles={customStyles}
                    />
                </CardBody>
            </Card>

            <Modal isOpen={verModal} className="modal-preguntas">
                <ModalHeader className="modal-header1">
                    <div class="box">
                        <div>   Mantenimiento de Articulos </div>
                        <div><a className="btn" style={{ color: "#ffff" }} onClick={cerrarModal}>X</a></div>
                    </div>
                </ModalHeader>
                <ModalBody>
                    <Row>
                        <Col md={6 }>
                            <FormGroup>

                                <Label>Descripcion</Label>
                                <Input bsSize="sm" name="descripcion" onChange={handleChange} value={tabla.descripcion} />
                            </FormGroup></Col>
                      
                        <Col hidden md={3}>
                            <FormGroup>

                                <Label>Grupo de Articulo</Label>
                                {/*<Input bsSize="sm" name="grupoArticulo" onChange={handleChange} value={tabla.grupoArticulo} />*/}
                                <Input bsSize="sm" type={"select"} name="grupoArticulo" onChange={handleChange} value={tabla.grupoArticulo} >
                                {/*   <option value={0}>Seleccionar</option>*/}
                                    {
                                        ListadoGrupoArt.map((item) => (<option key={item.idCategoria} value={item.idCategoria}>{item.descripcion}</option>))
                                    }

                                </Input>
                            </FormGroup>
                        </Col>
                        <Col md={3}>
                            <FormGroup>

                                <Label>Codigo de barra</Label>

                                {ListadoGrupoArt.filter(item => (item.grupoArticuloID == tabla.grupoArticulo)).map(x =>x.prefijo)}
                                <Input bsSize="sm" name="codigoAuxiliar" onChange={handleChange} value={tabla.codigoAuxiliar} />
                            </FormGroup></Col>
                        <Col hidden md={3} >
                            <FormGroup>

                                <Label>Activo Fijo</Label>
                                <Input bsSize="sm" name="activoFijo" onChange={handleChange} value={tabla.activoFijo} />
                            </FormGroup></Col> 


                        <Col  md={3}>
                            <FormGroup>

                                <Label>Almacen por Defecto</Label>
                                {/*<Input bsSize="sm" name="almacenPorDefecto" onChange={handleChange} value={tabla.almacenPorDefecto} />*/}
                                <Input className="form-control" bsSize="sm" type={"select"} name="almacenPorDefecto" onChange={handleChange} value={tabla.almacenPorDefecto}  >
                                    {/*<option value={0}>Seleccionar</option>*/}
                                    {
                                        ListadoAlmacen.map((item) => (<option key={item.almacenID} value={item.almacenID}>{item.descripcion}</option>))
                                    }

                                </Input>
                            </FormGroup></Col>
                          <Col  md={3}>
                            <FormGroup>

                                <Label>Tipo Articulo</Label>
                              
                                <Input className="form-control" bsSize="sm" type={"select"} name="tipoArticulo" onChange={handleChange} value={tabla.tipoArticulo}  >
                                    <option value={0 }>Articulo Almacen</option> 
                                    <option value={1 }>Servicio</option> 
                                </Input>
                            </FormGroup></Col>
                        

                        <Col md={3} >
                            <FormGroup>

                                <Label>% de Ganancias</Label>
                                <Input bsSize="sm" name="margen" onChange={handleChange} value={tabla.margen} />
                            </FormGroup></Col>
                        <Col md={3} >
                            <FormGroup>

                                <Label>Costo Promedio</Label>
                                <Input bsSize="sm" name="costoPromedio" onChange={handleChange} value={tabla.costoPromedio} />
                            </FormGroup></Col>

                        <Col md={3} >
                            <FormGroup>

                                <Label>Precio Promedio</Label>
                                <Input bsSize="sm" name="precioPromedio" onChange={handleChange} value={tabla.precioPromedio} />
                            </FormGroup></Col>
                       <Col md={3} >
                            <FormGroup>
               
                                <Label>Precio al Por Mayor</Label>
                                <Input bsSize="sm" name="precioPormayor" onChange={handleChange} value={tabla.precioPormayor} />
                            </FormGroup></Col>

                        <Col md={3} >
                            <FormGroup>
               
                             
                                <Label>Marca</Label>
                                <Input bsSize="sm" name="marca" onChange={handleChange} value={tabla.marca} />
                            </FormGroup></Col>
                      
                        <Col hidden md={3} >
                            <FormGroup>

                                <Label>Minimo en Stock</Label>
                                <Input bsSize="sm" name="cantidadMinima" onChange={handleChange} value={tabla.cantidadMinima} />
                            </FormGroup></Col>    <Col hidden md={3} >
                            <FormGroup>

                                <Label>Maximo en Stock</Label>
                                <Input bsSize="sm" name="cantidadMaxima" onChange={handleChange} value={tabla.cantidadMaxima} />
                            </FormGroup></Col>
                        {/*<Col md={3} >*/}
                        {/*    <FormGroup>*/}
                        {/*        <Label>Unidad de Medida</Label>*/}
                        {/*        */}{/*<Input bsSize="sm" name="unidadMedida" onChange={handleChange} value={tabla.unidadMedida} />*/}
                        {/*        <Input bsSize="sm" type={"select"} name="unidadMedida" onChange={handleChange} value={tabla.unidadMedida}  >*/}
                        {/*            <option value={0}>Seleccionar</option>*/}
                        {/*            {*/}
                        {/*                ListadoUnidaMedida.map((item) => (<option key={item.unidadMedidaID} value={item.unidadMedidaID}>{item.descripcion}</option>))*/}
                        {/*            }*/}
                        {/*        </Input>*/}
                        {/*    </FormGroup></Col>*/}

                        <Col hidden md={3} >
                            <FormGroup>

                                <Label>Tiempo Expiracion en Meses</Label>
                                <Input bsSize="sm" name="tiempoExpiracionMeses" onChange={handleChange} value={tabla.tiempoExpiracionMeses} />
                            </FormGroup></Col>

                        <Col hidden md={3} >
                            <FormGroup>

                                <Label>Ubicacion Almacen</Label>
                                <Input bsSize="sm" name="ubicacionAlmacen" onChange={handleChange} value={tabla.ubicacionAlmacen} />
                            </FormGroup></Col>
                        <Col hidden md={6} >
                            <FormGroup>

                                <Label>Tamaño o Dimension</Label>
                                <Input bsSize="sm" name="tamano" onChange={handleChange} value={tabla.tamano} />
                            </FormGroup></Col>
                        <Col hidden md={8} >
                            <FormGroup>

                                <Label>Imagen</Label>
                               {/*<Input bsSize="sm" name="imagen" onChange={handleChange} value={tabla.imagen} />*/}
                                <div hidden={tabla.articuloID==0}> <CagarImagenesArticulos ArtID={""+tabla.articuloID} /></div> 

                                <img className="card-img-top" style={{ width: "200px" }}  src={"./imagenarticulosSS/" + tabla.articuloID +".jpg"} alt="Card image cap" />

                            </FormGroup></Col>
                     
                    </Row>
                    <Col md={12} >
                        <FormGroup>
                            <Form>   <Form.Check
                                type="switch"
                                name="cambiarDescripcion"
                                checked={tabla.cambiarDescripcion}
                                onChange={handleChange}
                            /> .......Cambiar Descripcion
                                <Form.Check
                                    type="switch"
                                    name="cambiarPrecio"
                                    checked={tabla.cambiarPrecio}
                                    onChange={handleChange}
                                /> .......Cambiar Precio
                            <Form.Check
                                    type="switch"
                                    name="itbisIncluido"
                                    checked={tabla.itbisIncluido}
                                    onChange={handleChange}
                                /> .......ITBIS Incluido
                                      <Form.Check
                                    type="switch"
                                    name="esOferta"
                                    checked={tabla.esOferta}
                                    onChange={handleChange}
                                /> .......Es Oferta
                                <Form.Check
                                    type="switch"
                                    name="paraBot"
                                    checked={tabla.paraBot}
                                    onChange={handleChange}
                                /> .......Pata Bot


                            </Form>
                        </FormGroup>
                    </Col>
                    <div className="mt-3">
                        <img src={imageSrc} alt="Imagen cargada" width="200" className="rounded shadow-sm" />
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button size="sm" color="primary"
                        onClick={guardarCambios}
                    >Guardar</Button>
                    <Button size="sm" color="danger"
                        onClick={cerrarModal}
                    >Cerrar</Button>
                </ModalFooter>
            </Modal>


            {/*AYUDA TUTORIAL*/}
            <Modal className="modal-preguntas" isOpen={interativo}>
                <ModalHeader className="modal-header1">
                    Manuales interativo.
                </ModalHeader>
                <ModalBody>
                    <Row>
                        <FormGroup>
                            {/*<a href="\imagen\Manual de usuario Sistema Evaluación de Desempeño ETED.pdf" target="_blank" >Descargar Manual PDF</a>*/}
                            <video width="100%" height="70%" controls>
                                <source src="\imagen\Articulos.mp4" type="video/mp4" />
                            </video>

                            <Button size="sm" color="danger"
                                onClick={() => Setinterativo(false)}
                            >Cerrar</Button></FormGroup>
                    </Row>
                </ModalBody>

            </Modal>


            <Modal isOpen={verModalFoto} className="modal-preguntas1">
                <ModalHeader className="modal-header1">
                    <div class="box">
                        <div>   Subir Foto de Articulo </div>
                        <div><a className="btn" style={{ color: "#ffff" }} onClick={cerrarModal}>X</a></div>
                    </div>
                </ModalHeader>
                <ModalBody>
                    <Row>
                        <CardBody>
                            <CardTitle tag="h5">Imagen de Articulo / servicio</CardTitle>
                            <FormGroup>
                                <Label for="fileInput">Seleccionar Imagen</Label>
                                <Input type="file" id="fileInput" onChange={handleFileChange} />
                                <FormText color="muted">Formato recomendado: JPG o PNG. Tamaño máximo: 2MB.</FormText>

                                {(file != null) && <Button color="primary" size="sm" onClick={handleUpload}>Guardar</Button>}
                                {imageSrc && (
                                    <div className="mt-3">
                                        <img src={imageSrc} alt="Imagen cargada" width="200" className="rounded shadow-sm" />
                                    </div>
                                )}</FormGroup>
                        </CardBody>
                    </Row>
                </ModalBody>
                <ModalFooter>
                    <Button size="sm" color="danger"
                        onClick={cerrarModal}
                    >Cerrar</Button>
                </ModalFooter>
            </Modal>
     

        </>
    )

}
export default Articulos;